"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _regeneratorRuntime = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _createSuper = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _inherits = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SignalingClientConnectionRequest_1 = require("../signalingclient/SignalingClientConnectionRequest");

var SignalingClientEventType_1 = require("../signalingclient/SignalingClientEventType");

var BaseTask_1 = require("./BaseTask");

var OpenSignalingConnectionTask = /*#__PURE__*/function (_BaseTask_1$default) {
  _inherits(OpenSignalingConnectionTask, _BaseTask_1$default);

  var _super = _createSuper(OpenSignalingConnectionTask);

  function OpenSignalingConnectionTask(context) {
    var _this;

    _classCallCheck(this, OpenSignalingConnectionTask);

    _this = _super.call(this, context.logger);
    _this.context = context;
    _this.taskName = 'OpenSignalingConnectionTask';
    _this.taskCanceler = null;
    return _this;
  }

  _createClass(OpenSignalingConnectionTask, [{
    key: "cancel",
    value: function cancel() {
      if (this.taskCanceler) {
        this.taskCanceler.cancel();
        this.taskCanceler = null;
      }
    }
  }, {
    key: "run",
    value: function run() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var configuration, startTimeMs;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                configuration = this.context.meetingSessionConfiguration;
                this.context.signalingClient.openConnection(new SignalingClientConnectionRequest_1.default(configuration.urls.signalingURL, configuration.credentials.joinToken));
                startTimeMs = Date.now();
                _context.prev = 3;
                _context.next = 6;
                return new Promise(function (resolve, reject) {
                  var WebSocketOpenInterceptor = /*#__PURE__*/function () {
                    function WebSocketOpenInterceptor(signalingClient) {
                      _classCallCheck(this, WebSocketOpenInterceptor);

                      this.signalingClient = signalingClient;
                    }

                    _createClass(WebSocketOpenInterceptor, [{
                      key: "cancel",
                      value: function cancel() {
                        this.signalingClient.removeObserver(this);
                        reject(new Error("OpenSignalingConnectionTask got canceled while waiting to open signaling connection"));
                      }
                    }, {
                      key: "handleSignalingClientEvent",
                      value: function handleSignalingClientEvent(event) {
                        switch (event.type) {
                          case SignalingClientEventType_1.default.WebSocketOpen:
                            this.signalingClient.removeObserver(this);
                            resolve();
                            break;

                          case SignalingClientEventType_1.default.WebSocketFailed:
                            this.signalingClient.removeObserver(this);
                            reject(new Error('WebSocket connection failed'));
                            break;
                        }
                      }
                    }]);

                    return WebSocketOpenInterceptor;
                  }();

                  var interceptor = new WebSocketOpenInterceptor(_this2.context.signalingClient);

                  _this2.context.signalingClient.registerObserver(interceptor);

                  _this2.taskCanceler = interceptor;
                });

              case 6:
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](3);
                throw _context.t0;

              case 11:
                _context.prev = 11;
                this.context.signalingOpenDurationMs = Math.round(Date.now() - startTimeMs);
                this.logger.info("Opening signaling connection took ".concat(this.context.signalingOpenDurationMs, " ms"));
                return _context.finish(11);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 8, 11, 15]]);
      }));
    }
  }]);

  return OpenSignalingConnectionTask;
}(BaseTask_1.default);

exports.default = OpenSignalingConnectionTask;